import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { ActivatedRoute } from '@angular/router';
import * as Survey from "../survey.angularN.js";
import { MessageService } from 'primeng/api';

Survey.JsonObject.metaData.addProperty("questionbase", "popupdescription:text");
Survey.JsonObject.metaData.addProperty("page", "popupdescription:text");
Survey.StylesManager.applyTheme("default");
@Component({
  selector: 'app-diligenciar',
  standalone: true,
  imports: [],
  templateUrl: './diligenciar.component.html',
  styleUrl: './diligenciar.component.css'
})
export class DiligenciarComponent implements OnInit{

  title='Goyn';
  id;
  formulario;
  surveyJson;
  Nombre;
  Descripcion;
  grabaraudio;
  agregarsujeto;
  campoidentificador;
  campodescripcion;
  resultado="";
  resultadovisible=false;
  tiemporestante=5;
  constructor(private route: ActivatedRoute, private data: DataService, private messageService: MessageService) {  
   
    this.id = this.route.snapshot.paramMap.get('id');

  }
  ngOnInit(): void {

    this.data.ObtenerFormularioPublico(this.id).subscribe(x => {
      this.formulario = x;
      this.surveyJson=this.formulario["Definicion"];
      this.Nombre = this.formulario["Definicion"]["title"];
      this.Descripcion = this.formulario["Definicion"]["description"];
      this.agregarsujeto=true;
      this.campoidentificador = this.formulario["CampoIdentificador"];
      this.campodescripcion = this.formulario["CampoDescripcion"];



      const survey = new Survey.Model(this.surveyJson);


      Survey.SurveyNG.render("surveyContainer", { model: survey });

      console.log("================this.formulario====================");
      console.log(this.formulario);

      function fecha(params) {
        alert("fecha");

        var formato = params[0];
        console.log(params);

        const fecha = new Date();

        let dia = fecha.getDate();
        let mes = fecha.getMonth() + 1;
        let anio = fecha.getFullYear();

        let dias;
        dias = dia < 10 ? '0' + dia : dia;

        let mess;
        mess = mes < 10 ? '0' + mes : mes;

        switch (formato) {
          case 1:
            return dia + '/' + mess + '/' + anio;
          case 2:
            return mess + '/' + dias + '/' + anio;
          case 3:
            return anio + '-' + mess + '-' + dia;
          case 4:
            return anio + mess + dia;
          default:
            return dias + '/' + mess + '/' + anio;
        }

      }

      Survey.FunctionFactory.Instance.register("fecha", fecha);

      survey.onComplete.add(async (result, options) => { 
        //alert(JSON.stringify(result.data));
        var respuestas = result.data;

        var registro = {
            IdEncuesta: this.id,
            Identificacion: respuestas[this.campoidentificador],            
            Estado: '2',
            Respuestas: respuestas
        };

        //mostrar spinner
        this.resultadovisible=false;
        // mostrar mensaje en el centro
        
        this.messageService.add({severity:'info', summary: 'Revisando documentos', detail: 'Por favor espere...', sticky: true, closable: false});
        this.data.EnviarDiligenciado(registro).subscribe(response => {
            console.log(response);
            this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Formulario enviado exitosamente'});
            this.resultado="Formulario enviado exitosamente";
            this.resultadovisible=true;
            this.tiemporestante=5;
            //ocultar spinner
            this.messageService.clear();  
            this.messageService.add(
              {
                severity: 'success',
                summary: 'Documentos recibidos',
                detail: 'Sus documentos han sido recibidos y están siendo procesados. Recibirá una notificación una vez que se complete el análisis.',
                sticky: true,
                closable: false 
              }
                 
            );          
        }, error => {
            console.error('Error al enviar el formulario:', error);
            console.log(error);            
            // this.messageService.add(
            //   {severity:'error', summary: 'Error al enviar el formulario', detail: error.error.error}
              
            // );
            this.messageService.clear();

                        this.messageService.add(
              {
                severity: 'error',
                summary: 'Error al enviar el formulario',
                detail: error.error.error,
                sticky: true,
                closable: false 
              }
                 
            );
        });

      });
    });
  }
}
